import React, {Component} from 'react';
import {Link, NavLink} from 'react-router-dom';
import FontAwesome from 'react-fontawesome';
import * as firebase from 'firebase';
import logo from './vexpo-logo.png';
import './navigation-bar.css';

/** @class NavigationBar
  * A component for rendering navigation options
  * in the Vexpo editor and displaying connection
  * state.
  */
export default class NavigationBar extends Component {
  /** @constructor
    * Constructs a new instance of the component.
    */
  constructor(props) {
    super(props);
    this.state = {connected: false}
    this.firebaseRef = firebase.database().ref('.info/connected');
    this.signOut = this.signOut.bind(this);
  }
  /** @componentWillMount
    * Connects the component to the firebase database
    * to report on connection state.
    */
  componentWillMount() {
    this.firebaseRef.on('value', snapshot => {
      this.setState({connected: snapshot.val()});
    });
  }
  /** @function componentWillUnmount
    * Disconnects the component from the database
    */
  componentWillUnmount() {
    this.firebaseRef.off();
  }
  /** @function signout
    * Signs the current user out of the application.
    */
  signOut() {
    firebase.auth().signOut()
  }
  /** @function render
    * Renders the component.
    */
  render() {
    var navLinks = [];
    if(this.props.expoID) {
      navLinks.push(<NavLink to={`/expos/${this.props.expoID}/properties`} key="properties">Expo</NavLink>);
      navLinks.push(<NavLink to={`/expos/${this.props.expoID}/entry`} key="entry">Entry</NavLink>);
      navLinks.push(<NavLink to={`/expos/${this.props.expoID}/lobby`} key="lobby">Lobby</NavLink>);
      navLinks.push(<NavLink to={`/expos/${this.props.expoID}/halls`} key="halls">Halls</NavLink>);
      navLinks.push(<NavLink to={`/expos/${this.props.expoID}/booths`} key="booths">Booths</NavLink>);
      navLinks.push(<NavLink to={`/expos/${this.props.expoID}/products`} key="products">Products</NavLink>);
    }
    return (
      <nav>
        <Link to='/expos' className="brand">
          <img src={logo} alt=""/>
        </Link>
        <div className="links">
          {navLinks}
        </div>
        <div className="pull-right">
          <span className="status">
            <FontAwesome name="signal" />
            currently {this.state.connected ? 'online' : 'offline'}
          </span>
          <a onClick={this.signOut}>
            Sign Out
            <FontAwesome name="sign-out"/>
          </a>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation-bar/navigation-bar.js